// import React, { Fragment } from "react";
// import PropTypes from "prop-types";
// import SafeHTML from "./SafeHTML";
// import style from '../../scss/components/GenericTextArea';
// export default class GenericTextArea extends React.Component {
//     static propTypes = {
//         content: PropTypes.string
//     };
//     render() {
//         return (
//             <section className="rich-section">
//                 <div className="casestudy-audio">
//                     <span>
//                         <b>Listen now</b>
//                     </span>
//                     <audio className="wp-audio-shortcode" id="audio-90-4" preload="none" style="width: 100%;" controls="controls"> 
//                         <source type="audio/mpeg" src="https://hunterlab-audio-files.s3.amazonaws.com/e1156a84-de5b-4c26-9e6d-ac3753e3eff7.mp3?_=4" /> 
//                     </audio>
//                 </div>
//                 <div className="container">
//                     <div className="rich-content">
//                         <SafeHTML>{this.props.content}</SafeHTML>
//                     </div>
//                 </div>
//             </section>
//         );
//     }
// }

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "./SafeHTML";
import style from '../../scss/components/GenericTextArea';
export default class GenericTextArea extends React.Component {
    static propTypes = {
        content: PropTypes.string
    };
    render() {
        return (
            <section className="rich-section">
                <div className="container">
                    <div className="rich-content">
                        <SafeHTML>{this.props.content}</SafeHTML>
                    </div>
                </div>
            </section>
        );
    }
}

